import React from 'react';
import './Badge.css';

const Badge = ({ children, variant = 'default', icon }) => (
  <span className={`badge badge-${variant}`}>
    {icon && <span className="badge-icon">{icon}</span>}
    {children}
  </span>
);

export default Badge;
